import { useAppState } from "./useReduxState"
import { FetchState } from "../Models/Client/FetchState"
import { getItemList, getPageToFetch } from "../Models/Client/RemoteData"
import { Result } from "../Models/Utility/Result"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getGroundTruthList } from "../Actions/API/AppInstance/AppInstanceBaselineDataActions"
import { APIGroundTruthModel } from "../Models/API/APIGroundTruthModel"
import { FilterAndSortExpression } from "../Models/Client/FilterAndSortExpression"

export function useGroundTruthList(
    appID: string,
    params: FilterAndSortExpression<APIGroundTruthModel>
): FetchState<{
    items: APIGroundTruthModel[]
    total: number
}> {
    const dispatch = useDispatch()
    const entry = useAppState(state => state.api.baselineData.table[appID])

    useEffect(() => {
        const page = getPageToFetch(entry, params)

        if (page >= 0) {
            dispatch(getGroundTruthList(appID, page, undefined, params))
        }
    }, [dispatch, appID, entry, params])

    return useMemo(() => {
        if (
            entry === undefined ||
            entry.list === undefined ||
            JSON.stringify(params) !== JSON.stringify(entry.list.params)
        ) {
            return undefined
        }

        return Result.ok({
            items: getItemList(entry),
            total: entry.list.total
        })
    }, [entry, params])
}
